import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { State } from '../../../reducer';
import Modal from '../components/Modal';
import { dismissModal, cancelItems } from '../actions';
import { getOrder, getUiState, getError, getOperationLineItems } from '../selectors';

const mapStateToProps = (state: State) => ({
    state: getUiState(state),
    order: getOrder(state),
    error: getError(state),
    operationLineItems: getOperationLineItems(state),
});

const mapDispatchToProps = {
    dismissModal,
    cancelItems,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Modal));
